import z, { ZodType } from "zod";
import {
  type MaterialCharacteristics,
  type MaterialCharacteristicsWithoutShade,
} from "./materialCharacteristics.types";
import {
  shadeCharacteristicsSchema,
  type MultiShadeCharacteristics,
  type UniformShadeCharacteristics,
} from "../shade";

const baseSchema: ZodType<MaterialCharacteristics> = z.object({
  material: z.string(),
  shadeCharacteristics: shadeCharacteristicsSchema.optional(),
});

export const materialCharacteristicsSchema = baseSchema.superRefine(
  (value, ctx) => {
    if (value.material === "METAL_NON_PRECIOUS") {
      return;
    }

    if (
      !("shadeCharacteristics" in value) ||
      value.shadeCharacteristics == null
    ) {
      const shadeCharacteristicsPath: Array<
        keyof MultiShadeCharacteristics | keyof UniformShadeCharacteristics
      > = [
        "isMultiShade",
        "shadeType",
        "baseShade",
        "gingivalShade",
        "incisalShade",
        "shade",
      ];

      shadeCharacteristicsPath.forEach(path => {
        ctx.addIssue({
          code: "custom",
          path: ["shadeCharacteristics", path],
          message: `Shade characteristics ${path} are required for this material`,
        });
      });
    }
  }
);

export const materialCharacteristicsWithoutShadeSchema = z.object({
  material: z.string().min(1),
}) satisfies ZodType<MaterialCharacteristicsWithoutShade>;
